import React from 'react';
import './CustomButton.css';

const CustomButton = ({
  label,
  onClick,
  loading = false,
  disabled = false,
  type = 'button',
  className = '',
  icon = null,          // <-- optional React node (e.g., <FaPlus />)
  ariaLabel,            // optional accessibility override
}) => {
    const isDisabled = disabled || loading;


  return (
    <button
      type={type}
      className={`app-btn ${isDisabled ? 'is-disabled' : ''} ${loading ? 'is-loading' : ''} ${className}`}
      onClick={onClick}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      aria-label={ariaLabel || label}
    >
      {loading ? (
        <span className="app-btn__spinner" />
      ) : (
        <>
          {icon && <span className="app-btn__icon">{icon}</span>}
          <span className="app-btn__label">{label}</span>
        </>
      )}
    </button>
  );
};

export default CustomButton;
